import { Button, Form, Input, Spin } from "antd";
import React, { useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { showNotificationWithIcon } from "../../utils/helpers/helpers";
import { getUserInfo } from "../../utils/redux/reducers/User";
import { BreadCrumb } from "../main/LayoutComponents";
import { getStorageSettings, saveStorageSettings } from "./mediaApi";
import "./MediaStorageSetting.scss";

const i18n = Locale.getInstance();
const DEFAULT_ENDPOINT_HOST = "oss-cn-qingdao.aliyuncs.com";

function buildBucketUrl(bucket, endpointHost = DEFAULT_ENDPOINT_HOST) {
  const name = (bucket || "").trim();
  if (!name) {
    return "";
  }
  return `https://${name}.${endpointHost}`;
}

const MediaStorageSetting = () => {
  const user = useSelector((state) => getUserInfo(state));
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const bucketValue = Form.useWatch("bucket", form);

  const { data, isLoading } = useQuery(["storage-setting", user.token], () =>
    getStorageSettings({ token: user.token }),
  );

  const endpointHost = data?.data?.endpoint_host || DEFAULT_ENDPOINT_HOST;
  const previewUrl = buildBucketUrl(bucketValue, endpointHost);

  useEffect(() => {
    if (data?.data) {
      form.setFieldsValue({
        bucket: data.data.bucket || "",
      });
    }
  }, [data, form]);

  const saveStorageSettingMutation = useMutation(saveStorageSettings, {
    onSuccess: () => {
      queryClient.invalidateQueries("storage-setting");
      showNotificationWithIcon(i18n.t("media.saveFinished"), "success");
    },
    onError: (error) => {
      showNotificationWithIcon(error.message);
    },
  });

  const onFinish = (values) => {
    saveStorageSettingMutation.mutate({
      data: { bucket: values.bucket.trim() },
      token: user.token,
    });
  };

  const breadCrumbData = [
    {
      href: "/main/media/files",
      title: i18n.t("main.sideMenus.media"),
    },
    {
      title: i18n.t("main.sideMenus.storageSetting"),
    },
  ];

  if (isLoading) {
    return <Spin spinning={isLoading} />;
  }

  return (
    <>
      <BreadCrumb data={breadCrumbData} />
      <Form
        className="storage-settings"
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Bucket"
          name="bucket"
          rules={[{ required: true, message: "请输入 Bucket 名称" }]}
        >
          <Input placeholder="例如：my-shop-bucket" />
        </Form.Item>

        <Form.Item label="访问 URL">
          <Input value={previewUrl} readOnly placeholder="根据 Bucket 自动生成" />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={saveStorageSettingMutation.isLoading}
          >
            {i18n.t("sales.submit")}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default MediaStorageSetting;
